/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillrunResponse } from '../models/BillrunResponse';
import type { InvoiceResponse } from '../models/InvoiceResponse';
import type { MinimumSettlementAmountThresholdResponse } from '../models/MinimumSettlementAmountThresholdResponse';
import type { PartnerWithUnsettledAmountResponse } from '../models/PartnerWithUnsettledAmountResponse';
import type { StartBillrunStatusResponse } from '../models/StartBillrunStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BillingAdminService {
    /**
     * @returns StartBillrunStatusResponse Success
     * @throws ApiError
     */
    public static getApiBillingAdminStartBillrunStatus(): CancelablePromise<StartBillrunStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billing-admin/start-billrun-status',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns BillrunResponse Success
     * @throws ApiError
     */
    public static getApiBillingAdminBillruns(): CancelablePromise<Array<BillrunResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billing-admin/billruns',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns InvoiceResponse Success
     * @throws ApiError
     */
    public static getApiBillingAdminInvoices(): CancelablePromise<Array<InvoiceResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billing-admin/invoices',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns PartnerWithUnsettledAmountResponse Success
     * @throws ApiError
     */
    public static getApiBillingAdminPartnersWithUnsettledAmount(): CancelablePromise<Array<PartnerWithUnsettledAmountResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billing-admin/partners-with-unsettled-amount',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns MinimumSettlementAmountThresholdResponse Success
     * @throws ApiError
     */
    public static getApiBillingAdminMinimumSettlementAmountThreshold(): CancelablePromise<MinimumSettlementAmountThresholdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/billing-admin/minimum-settlement-amount-threshold',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    public static postApiBillingAdminStartBillrun(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/billing-admin/start-billrun',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
